<template>
    <div id="pcm-project-admin-view">
        <div class="container-fluid">
            <!-- Page Heading -->
            <div class="d-sm-flex align-items-center justify-content-between mb-4">
                <h1 class="h3 mb-0 text-gray-800">Quản trị Dự án (đang phát triển)</h1>
            </div>
            <!-- Content Row -->
            <div class="row">
                <div class="col-xl-12">
                    <div class="card mb-4 border-left-primary">
                        <div class="card-body">
                            <h6>Điều kiện lọc</h6>
                            <div>
                                <el-tabs v-model="form.filter.type" @tab-click="loadData()" >
                                    <el-tab-pane name="all">
                                        <span slot="label">Tất cả <span class="badge btn-primary badge-counter">{{projects.count.count_project}}</span></span>
                                    </el-tab-pane>
                                    <el-tab-pane name="1">
                                        <span slot="label">Hoạt động <span class="badge btn-success  badge-counter">{{projects.count.count_active}}</span></span>
                                    </el-tab-pane>
                                    <el-tab-pane name="2">
                                        <span slot="label">Đóng <span class="badge badge-secondary badge-counter">{{projects.count.count_block}}</span></span>
                                    </el-tab-pane>
                                </el-tabs>
                            </div>
                            <div>
                                <el-input placeholder="Nhập tên dự án" v-model="form.filter.keyword" clearable>
                                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                                   
                                </el-input>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12">
                    <div class="card shadow mb-4" v-loading="loadingState.projectList">
                        <div class="card-header py-3 d-flex flex-row align-items-center justify-content-between">
                            <h5 class="m-0 font-weight-bold text-primary">Danh sách dự án</h5>
                            <div class="dropdown no-arrow">
                                <el-button size="mini" type="success" @click="resetFormProject(); dialogVisible.project = true" >Thêm mới</el-button>
                            </div>
                        </div>

                        <div class="card-body pt-1">
                            <el-table :data="projects.list" style="width: 100%" @row-dblclick="rowDbClick">
                                <el-table-column prop="id" label="Tên">
                                    <template slot-scope="scope" >
                                        <div class="d-flex">
                                            <div class="pr-2">
                                                <avatar :username="scope.row.name" :size="45"></avatar>
                                            </div>
                                            <div class="project-item-name">
                                                <span class="font-weight-bold">
                                                   {{scope.row.name}}
                                                   <span v-if="scope.row.status == 0" class="badge badge-secondary badge-counter">Đã đóng</span>
                                                </span>
                                                <br>
                                                <span>{{ scope.row.description }}</span>
                                            </div>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Ngày bắt đầu"  width="180">
                                    <template slot-scope="scope">
                                        <span>{{scope.row.start_date | formatDate}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="Ngày kết thúc" width="180">
                                    <template slot-scope="scope">
                                        <span v-if="scope.row.status == 1 && Date.parse(scope.row.end_date) < Date.now() " style="color:red;">{{scope.row.end_date | formatDate}}</span>
                                        <span v-else>{{scope.row.end_date | formatDate}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="#" align="center" width="140">
                                    <template slot-scope="scope">
                                        <el-button size="mini" @click="editProject(scope.row)">Sửa</el-button>
                                        <el-button  type="danger" size="mini" @click="deleteProject(scope.row.id)">Xóa</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <!-- Dialog - Project -->
        <form role="form" @submit.prevent="submitFormProject">
            <el-dialog title="Thông tin dự án"
                       custom-class="el-dialog-body-gray"
                       :visible.sync="dialogVisible.project" 
                       width="500px"
            >
                <div v-loading="loadingState.projectForm">
                    <div class="row form-group">
                        <div class="col-sm-12">
                            <label class="required">Tên dự án</label>
                            <div>
                                <el-input size="small"
                                    v-model="form.project.name"
                                    v-validate="'required'"
                                    data-vv-name="name" data-vv-as="Tên dự án"
                                    :class="{'is-invalid': errors.has('name')}"
                                />
                            </div>
                        </div>
                       
                    </div>
                    <div class="row form-group">
                       <div class="col-sm-12">
                            <label class="required">Mô tả</label>
                            <div>
                                <el-input size="small"
                                    v-model="form.project.description"
                                    v-validate="'required'"
                                    data-vv-name="description" data-vv-as="Mô tả"
                                    :class="{'is-invalid': errors.has('description')}"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="row form-group">
                        <div class="col-sm-12">
                            <label>Thời gian</label>
                             <div>
                                <el-date-picker
                                    v-model="form.project.dates"
                                    type="daterange"
                                    start-placeholder="Ngày bắt đầu"
                                    end-placeholder="Ngày kết thúc"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    format="dd/MM/yyyy"
                                    >
                                    
                                </el-date-picker>
                            </div>
                        </div>
                    </div>
                     <div class="row form-group">
                       
                       <div class="col-sm-12">
                            <label>Thưởng</label>
                            <div>
                                <el-input size="small"
                                    v-model="form.project.bonus"
                                    v-validate="'required'"
                                    data-vv-name="bonus" data-vv-as="Thưởng"
                                />
                            </div>
                        </div>
                    </div>
                    
                  
                </div>
                <div slot="footer" class="dialog-footer d-flex justify-content-between">
                    <div>
                        
                        <el-switch v-model="form.project.status"
                            inactive-text="Hoạt động"
                            inactive-color = "#13ce66"
                            active-color = "#C0CCDA"
                            :active-value = "0"
                            :inactive-value = "1"
                        >
                        </el-switch> 
                    </div>  
                    <button type="submit" class="btn btn-sm btn-primary btn-icon-split"  :disabled="loadingState.projectForm">
                        <span class="icon text-white-50">
                            <i class="fas fa-save"></i>
                        </span>
                        <span class="text">Lưu</span>
                    </button>
                </div>
            </el-dialog>
        </form>
    </div>
</template>

<script>
import _ from 'lodash'
import Avatar from 'vue-avatar'
import moment from 'moment'
import API_PROJECT from '@/utils/api/project'

export default {
    name: 'pcm-project-admin-view',
    components: {
        Avatar
    },
    data() {
        return {
            loadingState: {
                projectList: false,
                projectForm: false
            },
        
            dialogVisible: {
                project: false
            },

            form: {
                filter: {
                    type: 'all',
                    keyword: ''
                },
                project: {
                    id: 0,
                    name: '',
                    description: '',
                    dates: ['',''],
                    status: 1,
                    bonus:0
                    
                    
                }
            },
            projects:{
                list: [],
                count: [],

            }

        }
    },
    created() {
        let self = this;
        this.$emit('activeMenu', 'project_admin');
        self.loadData()
    },
    watch: {
        'form.filter.keyword': _.debounce(function(newVal, oldVal) {
                                    this.loadData()
                                    },
                                    500 
                                )
    },
    methods: {
        loadData(){
           let self = this
            self.loadingState.projectList = true
            API_PROJECT.getList(self.$axios, self.form.filter, function(data) {
                self.loadingState.projectList = false
                if (data.status) {
                    self.projects = data.data
                } else {
                    self.showMessage('error', data.error_message)
                }
            }, function(error) {
                self.loadingState.projectList = false
            })
        },
        rowDbClick(row) {
            this.editProject(row)
        },
        submitFormProject(){
           let self = this
            self.$validator.validateAll().then((result) => {
                if (result) {
                    self.loadingState.projectForm = true
                    if (self.form.project.id == 0) {
                        API_PROJECT.save(self.$axios, self.form.project, function (data) {
                            self.loadingState.projectForm = false
                            if (data.status) {
                                self.showMessage('success', 'Thêm mới dự án thành công!')
                                self.resetFormProject()
                                self.dialogVisible.project = false
                                self.loadData()
                            } else {
                                if (data.error_code == 103) {
                                    self.showInValidMessage(data.data)
                                }
                            }
                        }, function (error) {
                            self.loadingState.projectForm = false
                        })
                    } else {
                        API_PROJECT.update(self.$axios, self.form.project, function (data) {
                            self.loadingState.projectForm = false
                            if (data.status) {
                                self.showMessage('success', 'Chỉnh sửa dự án thành công!')
                                self.resetFormProject()
                                self.dialogVisible.project = false
                                self.loadData()
                            } else {
                                if (data.error_code == 103) {
                                    self.showInValidMessage(data.data)
                                }
                            }
                        }, function (error) {
                            self.loadingState.projectForm = false
                        })
                    } 
                }
            })

        },
        resetFormProject() {
            this.$validator.reset()
            this.form.project = {
                id: 0,
                name: '',
                description: '',
                dates: ['',''],
                status: 1,
                bonus:0
            }
        },
        editProject(row){
           let self = this
            if (self.form.project.id == row.id) {
                return self.dialogVisible.project = true
            }
            self.resetFormProject()
            
            self.form.project.name = row.name
            self.form.project.description = row.description
            self.form.project.bonus = row.bonus
            self.form.project.status = row.status
            self.form.project.id = row.id
            if(row.start_date != null && row.end_date != null){
                self.form.project.dates = [
                    moment(row.start_date).format('YYYY-MM-DD h:mm:ss'),
                    moment(row.end_date).format('YYYY-MM-DD h:mm:ss')
                ]
            } else{
                self.form.project.dates = ['','']
            }

            self.dialogVisible.project = true
        },
        deleteProject(id){
            let self = this
            let content = 'Bạn có chắc chắn muốn xóa'
            this.showConfirmLoadingMessage('warning', 'Xóa Project', content, (action, instance, done) => {
                if (action === 'confirm') {
                    instance.confirmButtonLoading = true
                    let form = {
                        id: id
                    }
                    API_PROJECT.delete(self.$axios, form, (data) => {
                        instance.confirmButtonLoading = false
                        if (data.status) {
                            self.showMessage('success', 'Xóa thành công !')
                            done()
                            self.loadData()
                        }
                    }, (error) => {
                        instance.confirmButtonLoading = false
                    })
                } else {
                    done();
                }
            })

        },

    }
}
</script>

